module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Light.woff?0f0118feb71664927ea7fb8015778795";